<script>
    module.exports = {
         methods: {
            create_marking_list() {
                let loader = this.$loading.show()
                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.axios.post(process.env.VUE_APP_API_URL + '/api/marking_list', this.marking_list)
                .then(response => {
                    this.operation_info = response.data.data
                    this.isSuccess = true
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
            },
            list(company_id) {
                let loader = this.$loading.show()
                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.axios.get(process.env.VUE_APP_API_URL + '/api/marking_list/'+company_id)
                .then(response => {
                    this.marking_lists = response.data.data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
            },
            show_mklist(mklist_id) {
                let loader = this.$loading.show()
                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.axios.get(process.env.VUE_APP_API_URL + '/api/marking_list/show/'+mklist_id)
                .then(response => {
                    this.marking_list = response.data.data
                    this.aspects_list = response.data.aspects
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
            },
            delete_aspect(aspect_in_mklists_id) {
                let loader = this.$loading.show()
                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.axios.delete(process.env.VUE_APP_API_URL + '/api/marking_list/delete_aspect/'+aspect_in_mklists_id)
                .then(response => {
                    this.operation_info = response.data.data
                    this.isSuccess = true
                    this.show_mklist(this.list_id)
                    loader.hide()
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
            }
         }
    }
</script>